export const ATTENDANTLIST_STATUS = 'ATTENDANTLIST_STATUS';
export const ATTENDANTLIST_TWOFACTOR = 'ATTENDANTLIST_TWOFACTOR';